import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { findIndex as _findIndex } from 'lodash';

import { companyLocationOptionFromEntity } from 'components/forms/autocomplete/CompanyLocation';
import { categoryOptionFromEntity } from 'components/forms/autocomplete/Category';
import { brandOptionFromEntity } from 'components/forms/autocomplete/Brand';
import { modelOptionFromEntity } from 'components/forms/autocomplete/Model';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import Entity from 'components/Entity';
import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import FormSwitchery from 'components/forms/FormSwitchery';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';
import FormLangRichEditor from 'components/forms/FormLangRichEditor';
import FormHoldingCompany from 'components/forms/FormHoldingCompany';

import CmsCanvas from 'components/cms/CmsCanvas';

import { entityMetaMapping } from 'js/constants';

class CarData extends EntityPropsUpdater {
  // make sure there is a CMS description for given language
  getCmsDescriptionEntity = () => {
    const { entity, appIntl } = this.props;

    const descriptionIndex = _findIndex(entity.getCmsDescription(), ['language', appIntl.displayIntlForm]);
    if (descriptionIndex > -1) {
      return this.getEntityForCms(entity.getCmsDescription()[descriptionIndex]);
    }

    // create new value and return it
    const newValue = entity.getCmsDescription().slice();
    const newDescription = entity.createValue('cmsDescription', [], { language: appIntl.displayIntlForm });
    newValue.push(newDescription);

    this.updateEntity('cmsDescription', newValue);

    return this.getEntityForCms(newDescription);
  };

  getEntityForCms = data => {
    const entity = new Entity();
    entity.setData(data);
    entity.setMeta(this.props.meta, entityMetaMapping.cmsDescription);

    return entity;
  };

  updateDescriptionType = (e, descriptionType) => {
    e.preventDefault();
    e.stopPropagation();

    this.updateEntity('descriptionType', descriptionType);
  };

  updateCmsDescription = content => {
    const { entity, appIntl } = this.props;
    const descriptionIndex = _findIndex(entity.getCmsDescription(), ['language', appIntl.displayIntlForm]);
    this.updateEntity('content', content, ['cmsDescription', descriptionIndex.toString()]);
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
      owner,
      updateOwner,
    } = this.props;

    return (
      <div class="clearfix">
        {entityLoaded && (
          <div>
            <Row>
              <Col xs={12} md={inModal ? 12 : 6}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <p className="form-group-title">{messages.car}</p>
                    <div class="form-group-attached">
                      <FormHoldingCompany
                        onChange={updateOwner}
                        selectedClient={owner && owner.username}
                        disabled={disabled}
                      />
                      <FormAutocomplete
                        label={messages.category}
                        name="category"
                        value={categoryOptionFromEntity(entity.getCategory())}
                        meta={entity.getCategoryMetaInformation()}
                        validation={entity.getCategoryValidationResult()}
                        onChange={(name, value) => {
                          this.updateEntityMultiple([name, 'categoryPath'], [value, value.path]);
                        }}
                        returnValueObject
                        autocompleteType="category"
                        complete
                        disabled={disabled}
                      />
                      <FormAutocomplete
                        label={messages.brand}
                        name="brand"
                        value={brandOptionFromEntity(entity.getBrand())}
                        meta={entity.getBrandMetaInformation()}
                        validation={entity.getBrandValidationResult()}
                        onChange={this.updateEntity}
                        returnValueObject
                        autocompleteType="brand"
                        disabled={disabled}
                      />
                      <FormAutocomplete
                        urlFilters={
                          entity.getBrand() && entity.getBrand().getId()
                            ? { filters: { brand: entity.getBrand().getId() } }
                            : {}
                        }
                        label={messages.model}
                        name="model"
                        value={modelOptionFromEntity(entity.getModel())}
                        meta={entity.getModelMetaInformation()}
                        validation={entity.getModelValidationResult()}
                        onChange={this.updateEntity}
                        returnValueObject
                        autocompleteType="model"
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.name}
                        name="name"
                        value={entity.getName()}
                        meta={entity.getNameMetaInformation()}
                        validation={entity.getNameValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={inModal ? 12 : 6}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <p className="form-group-title">{messages.identification}</p>
                    <div class="form-group-attached">
                      <FormInput
                        label={messages.vin}
                        name="vin"
                        value={entity.getIdent().getVin()}
                        meta={entity.getIdent().getVinMetaInformation()}
                        validation={entity.getIdent().getVinValidationResult()}
                        onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.internal_car_reference}
                        name="internal"
                        value={entity.getIdent().getInternal()}
                        meta={entity.getIdent().getInternalMetaInformation()}
                        validation={entity.getIdent().getInternalValidationResult()}
                        onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                        disabled={disabled}
                      />
                      <FormInput
                        label={messages.license_plate_number}
                        name="licensePlateNumber"
                        value={entity.getIdent().getLicensePlateNumber()}
                        meta={entity.getIdent().getLicensePlateNumberMetaInformation()}
                        validation={entity.getIdent().getLicensePlateNumberValidationResult()}
                        onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                        disabled={disabled}
                      />
                    </div>

                    <p class="m-t-10 form-group-title">{messages.default_location}</p>
                    <div class="form-group-attached">
                      <FormAutocomplete
                        label={messages.location}
                        name="defaultLocation"
                        value={companyLocationOptionFromEntity(entity.getDefaultLocation())}
                        meta={entity.getDefaultLocationMetaInformation()}
                        validation={entity.getDefaultLocationValidationResult()}
                        onChange={(name, location) => {
                          this.updateEntity(name, {
                            id: location.id,
                            name: location.name,
                            street: location.street,
                            house_number: location.house_number,
                            apartment_number: location.apartment_number,
                            zip_code: location.zip_code,
                            city: location.city,
                            coordinates: { lat: location.coordinates.lat, lng: location.coordinates.lng },
                          });
                        }}
                        returnValueObject
                        autocompleteType="companyLocation"
                        urlFilters={owner ? { filters: { owner: owner.username } } : null}
                        complete
                        disabled={disabled}
                      />
                    </div>
                    <p class="m-t-10">{messages.visibility}</p>
                    <div>
                      <FormSwitchery
                        name="isActive"
                        checked={entity.getIsActive()}
                        value
                        label={messages.show_item_online}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                    <div class="m-t-5">
                      <FormSwitchery
                        name="isResource"
                        checked={entity.getIsResource()}
                        value
                        label={messages.use_as_resource}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    {entity.getDescriptionType() === 'cms' ? (
                      <a href="#useText" onClick={e => this.updateDescriptionType(e, 'text')}>
                        {messages.use_text_description}
                      </a>
                    ) : (
                      <a href="#useCms" onClick={e => this.updateDescriptionType(e, 'cms')}>
                        {messages.use_visual_builder}
                      </a>
                    )}

                    {entity.getDescriptionType() === 'cms' ? (
                      <div>
                        <div class="p-t-15 p-b-15">
                          <IntlFormInlineSelector /> {messages.description}
                        </div>
                        <CmsCanvas
                          editMode
                          entity={this.getCmsDescriptionEntity()}
                          changeEntity={cmsDescriptionEntity => {
                            this.updateCmsDescription(cmsDescriptionEntity.processedData.content);
                          }}
                          itemId={entity.getId()}
                        />
                      </div>
                    ) : (
                      <div class="form-group-attached">
                        <FormLangRichEditor
                          label={messages.description}
                          name="description"
                          value={entity.getDescription()}
                          meta={entity.getDescriptionMetaInformation()}
                          validation={entity.getDescriptionValidationResult()}
                          onChange={this.updateEntity}
                          disabled={disabled}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}
CarData.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    meta: state.entityMeta,
  };
};

export default injectIntl(connect(mapStateToProps)(CarData));
